// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;

  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: 0 25px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding: 0;
    margin: 40px 23px 45px 23px;
  }
`;
const Title = styled.div`
  padding: 30px calc(50% - 520px) 25px calc(50% - 520px);
  width: 1040px;

  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.07;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 30, 10, "vw")} 0
      ${scale(1100, 767, 25, 10, "vw")} 0;
    width: 100%;
    font-size: ${scale(1100, 767, 28, 24, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 22px;
    line-height: 1.2;
    letter-spacing: 0.3px;
  }
`;
const Items = styled.div`
  padding: 0 calc(50% - 520px) 35px calc(50% - 520px);
  display: flex;
  justify-content: space-between;
  align-items: stretch;

  @media (max-width: 1100px) {
    padding: 0 0 ${scale(1100, 767, 35, 10, "vw")} 0;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 35px 0 0 0;
    flex-wrap: wrap;
  }
`;

class SetArrowArticles extends ArticleAbstract {
  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        <Title>{first.title}</Title>
        <Items>{items.map(item => <ArrowArticle key={item.id} content={item} />)}</Items>
      </Wrapper>
    );
  }
}

export default SetArrowArticles;

const Item = styled.div`
  width: 182px;
  position: relative;

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 182, 135, "vw")};
  }

  @media (max-width: 700px) {
    width: calc(50% - 10px);
    margin: 5px 0;

    :nth-child(2n) {
      margin-left: 10px;
    }
    :nth-child(2n + 1) {
      margin-right: 10px;
    }
  }
`;
const ItemTitleContainer = styled.div`
  width: 100%;
  height: 44px;
  padding-bottom: 3px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 44, 32, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    height: 34px;
    padding-bottom: 8px;
    float: left;
  }
`;
const ItemTitle = styled.div`
  width: 100%;

  line-height: 22px;
  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  color: #3949ab;

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 13, "vw")};
    line-height: ${scale(1100, 767, 22, 16, "vw")};
  }
  @media (max-width: 700px) {
    line-height: 17px;
    font-size: 14px;
    letter-spacing: 0.2px;
  }
`;
const ItemBody = styled.div`
  width: 100%;
  float: left;
  padding-bottom: 30px;

  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.4);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 14, 11, "vw")};
    padding-bottom: ${scale(1100, 767, 30, 18, "vw")};
  }

  @media (max-width: 700px) {
    font-size: 11px;
    line-height: 1.55;
    padding-bottom: 14px;
  }
`;
const ArrowContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 5px;

  height: 22px;
  svg {
    height: 22px;
  }

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 22, 16, "vw")};
    svg {
      height: ${scale(1100, 767, 22, 16, "vw")};
    }
  }
  @media (max-width: 700px) {
    height: 14px;
    svg {
      height: 14px;
    }
  }
`;

class ArrowArticle extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        <ItemTitleContainer>
          <ItemTitle>{this.title()}</ItemTitle>
        </ItemTitleContainer>
        <ItemBody>
          <FlatBody>{this.body()}</FlatBody>
        </ItemBody>
        <ArrowContainer>
          <Arrow />
        </ArrowContainer>
      </Item>
    );
  }
}

class Arrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="19"
        viewBox="0 0 24 19"
      >
        <g fill="none" fillRule="evenodd" stroke="#3949AB">
          <path strokeLinecap="square" d="M.5 9.5h22.023" />
          <path d="M14 1l9.67 8.508L14.017 18" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetArrowArticles.js